import { useEffect, useState } from "react";
import { getDoc, doc } from "firebase/firestore";
import { db } from "@/firebaseConfig.js";
import { useAuth } from "../utils/auth.jsx"; // твой хук, который возвращает auth-пользователя

export function useCurrentUserFromFirestore() {
    const {user} = useAuth(); // текущий пользователь из Firebase Auth
    const [firestoreUser, setFirestoreUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUser = async () => {
            if (!user) {
                setFirestoreUser(null);
                setLoading(false);
                return;
            }

            try {
                const userRef = doc(db, "users", user.uid); 
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    setFirestoreUser({ id: userSnap.id, ...userSnap.data() });
                } else {
                    setFirestoreUser(null);
                }
            } catch (error) {
                console.error("Error fetching user from Firestore:", error);
                setFirestoreUser(null);
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, [user]);

    return { firestoreUser, loading };
}
